import request from '@/utils/request'


export function fetchProductForPandyTransfer(params) {
  return request({
    url:'smsPandyTransferItem/getProductForPandyTransfer/',
    method:'get',
    params:params
  })
}


export function fetchPandyItemList(pandyNo) {
    return request({
      url:'smsPandyTransferItem/pandyItemList/' + pandyNo,
      method:'get',
    })
  }


  export function fetchPandyItemHistoryList(ptItemNo) {
    return request({
      url:'/smsPandyTransferItem/pandyItemHistory/'+ ptItemNo,
      method:'get',
    })
  }
  

  export function fetchTransferItemList(transferNo) {
    return request({
      url:'smsPandyTransferItem/transferItemList/' + transferNo,
      method:'get',
    })
  }


  export function fetchTransferItemHistoryList(ptItemNo) {
    return request({
      url:'/smsPandyTransferItem/transferItemHistory/'+ ptItemNo,
      method:'get',
    })
  }
  
  
  export function createPandyTransfer(data) {
    return request({
      url:'/smsPandyTransferItem/create',
      method:'post',
      data:data
    })
  }
  
  export function updatePandyTransfer(id, data) {
    return request({
      url:'/smsPandyTransferItem/update/' + id,
      method:'post',
      data:data
    })
  }
  

  export function deletePandyTransfer(id, data) {
    return request({
      url:'/smsPandyTransferItem/delete/' + id,
      method:'post',
    })
  }